var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"placeholder":"請選擇年月","expand-trigger":"click","disabled":_vm.loading,"options":_vm.dateRange},on:{"change":_vm.beforeSelectDate},model:{value:(_vm.dateLocal),callback:function ($$v) {_vm.dateLocal=$$v},expression:"dateLocal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }